import Vue from 'vue'

import {
  Image,
  Carousel,
  CarouselItem,
  Input,
  Skeleton,
  SkeletonItem,
  Pagination,
  Form,
  FormItem,
  Button,
  Tooltip,
  Message,
  MessageBox,
  Loading
} from 'element-ui'

Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Tooltip)

Vue.use(Loading.directive)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
